<template>
  <div class="container-fluid">
    <div class="row header-row">
      <div class="col-12 col-lg-6 offset-lg-3">
        <h1>Update Password</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6 offset-lg-3">
        <div class="card">
          <h4>Update Password</h4>
          <form-component>
            <form
              id="change-password"
              data-vv-scope="change-password"
              novalidate="novalidate"
              @submit.prevent="doChangePassword"
            >
              <input-text
                id="oldPassword"
                ref="oldPassword"
                v-model="oldPassword"
                v-validate="'required'"
                name="oldPassword"
                data-vv-name="oldPassword"
                data-vv-as="oldPassword"
                label="Current Password"
                type="password"
                required
                :error="errors.first('change-password.oldPassword')"
              />
              <input-text
                id="password"
                ref="password"
                v-model="password"
                v-validate="'required'"
                name="password"
                data-vv-name="password"
                data-vv-as="password"
                label="Password"
                type="password"
                required
                :error="errors.first('change-password.password')"
              />
              <input-text
                id="confirm_password"
                v-model="confirm_password"
                v-validate="'required|confirmed:password'"
                name="confirm_password"
                data-vv-name="confirm_password"
                data-vv-as="password"
                label="Confirm Password"
                type="password"
                required
                :error="errors.first('change-password.confirm_password')"
              />
              <button
                :disabled="saving || resetting"
                class="btn btn-primary btn-large"
                type="submit"
              >
                <font-awesome-icon
                  v-if="resetting"
                  :spin="true"
                  :icon="['fas', 'spinner']"
                  class="icon alt"
                />
                <span v-else>Save</span>
              </button>
            </form>
          </form-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'UpdatePassword',
  components: {
    FormComponent,
    InputText,
  },
  props: {
    doCancel: {
      type: Function,
    },
    doSave: {
      type: Function,
    },
  },
  data() {
    return {
      userClient: new UserClient(this.$http),

      oldPassword: '',
      password: '',
      confirm_password: '',

      saving: false,
      resetting: false,
    };
  },
  methods: {
    doChangePassword() {
      this.$validator.validateAll('change-password').then((result) => {
        if (result) {
          this.errors.clear();
          this.resetting = true;

          this.userClient.changePassword(this.oldPassword, this.password).then(() => {
            this.resetting = false;
            this.$store.commit('setGlobalAlert', {
              msg: 'Password Changed!',
            });
            this.oldPassword = '';
            this.password = '';
            this.confirm_password = '';
          }).catch((e) => {
            this.resetting = false;
            let extraText = 'Please try again!';
            if (e && e.body && e.body.error && e.body.error.message) {
              extraText = e.body.error.message;
            }
            this.$store.commit('setGlobalAlert', {
              msg: `Unable to change password. ${extraText}`,
              error: true,
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  @include border-radius($border-radius);

  margin-bottom: 30px;
  padding: 45px;
  border: solid 1px #ddd;

  @media (max-width: $sm-max) {
    margin-bottom: 20px;
    padding: 30px;
  }

  h4 {
    margin-bottom: 20px;
    font-size: 20px;
  }
}

.inline-alert {
  margin-bottom: 25px;
  padding: 14px;
  color: $white;
  background: $red;
}
</style>
